import React, { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import ApiCustom from "../../utils/ApiCustom";
import { formatDate } from "../../utils/helps";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import {
  TrashIcon,
} from "@heroicons/react/24/outline";
import StatusDropdown from "../../components/admin/StatusDropdownButton";

const hasPermission = (requiredPermission) => {
  const userId = localStorage.getItem("userId");
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
    : [];
};

const Contact = () => {
  const [contacts, setContacts] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  
  const userId = localStorage.getItem("userId");
  useEffect(() => {
    if (hasPermission("CONTACT_SHOW")) {
      getData();
    }
  }, []);

  const getData = async () => {
    ApiCustom("/contact-show")
      .then((res) => {
        setContacts(res.data?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const getCompanyByUserId = () => {
    ApiCustom.get("/company-show-by-user-id?userId=" + userId)
      .then((res) => {
        getDataByCompanyId(res.data?.data?.id);
      })
      .catch((err) => console.log(err));
  };

  const getDataByCompanyId = async (id) => {
    ApiCustom("/contact-show-by-company-id/" + id)
      .then((res) => {
        setContacts(res.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const handleStatusChange = async (contactId, newStatus) => {
    try {
      await ApiCustom.put(`/contact-update/${contactId}`, {
        status: newStatus
      });
      toast.success("Cập nhật trạng thái thành công!");
      getData();
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi cập nhật trạng thái!");
    }
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };

  const handleDeleteContact = async () => {
      ApiCustom.delete("/contact-delete/" + deleteId)
      .then((res) => {
        toast.success("Xóa liên hệ thành công");
        handleCloseDeleteModal();
        getData();
      })
      .catch((err) => {
        toast.error("Có lỗi xảy ra khi xóa liên hệ");
      })
  };

  const headers = [
    {
      key: "id",
      label: "STT",
      render: (item, index) => (
        <div>
          <p className="font-medium">{index + 1}</p>
        </div>
      ),
    },
    {
      key: "name",
      label: "Họ và tên",
      render: (item) => (
        <div>
          <p className="font-medium">{item.name}</p>
        </div>
      ),
    },
    {
      key: "email",
      label: "Email",
      render: (item) => (
        <div>
          <p className="font-medium">{item.email}</p>
        </div>
      ),
    },
    {
      key: "phone",
      label: "Số điện thoại",
      render: (item) => (
        <div>
          <p className="font-medium">{item.phone}</p>
        </div>
      ),
    },
    {
      key: "product",
      label: "Sản phẩm",
      render: (item) => (
        <div>
          <p className="font-medium">{item?.product?.name}</p>
        </div>
      ),
    },
    {
      key: "company",
      label: "Đơn vị",
      render: (item) => (
        <div>
          <p className="font-medium">{item?.company?.companyName}</p>
        </div>
      ),
    },
    {
      key: "createdAt",
      label: "Thời gian",
      render: (item) => (
        <div>
          <p className="font-medium">{formatDate(item?.createdAt)}</p>
        </div>
      ),
    },
    // {
    //   key: "updatedAt",
    //   label: "Cập nhật",
    //   render: (item) => (
    //     <div>
    //       <p className="font-medium">{formatDate(item?.updatedAt)}</p>
    //     </div>
    //   ),
    // },
  ];

  if (hasPermission("CONTACT_UPDATE")) {
    headers.push(
      {
        key: "status",
        label: "Trạng thái",
        render: (item) => (
          <StatusDropdown
            options={[
              { value: "pending", label: "Đang chờ" },
              { value: "received", label: "Đã tiếp nhận" },
              { value: "processed", label: "Đã xử lý" }
            ]}
            value={item.status}
            onChange={(newStatus) => handleStatusChange(item.id, newStatus)}
            minWidth="w-32"
            getStatusStyle={(value) => {
              switch(value) {
                case "processed":
                  return "bg-green-100 text-green-800";
                case "received":
                  return "bg-blue-100 text-blue-800";
                default:
                  return "bg-yellow-100 text-yellow-800";
              }
            }}
          />
        )
      }
    )
  }

  if (hasPermission("CONTACT_DELETE")) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
       {hasPermission("CONTACT_DELETE") && (
          <button
            onClick={() => handleOpenDeleteModal(item.id)}
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    ),
  };

  const filterData = contacts.filter((item) =>
    searchValue === ""
      ? true
      : [item?.name, item?.email, item?.phone].some((field) =>
          field?.toLowerCase().includes(searchValue.toLowerCase())
        )
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Quản lý liên hệ</h1>
        <div className=" flex items-center space-x-2">
          <label
            htmlFor="userSearchFilter"
            className="text-sm font-medium w-24"
          >
            Tìm kiếm:
          </label>
          <input
            type="search"
            className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filterData}
          settings={tableSettings}
        />
      </div>

       <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDeleteContact}
      />
    </div>
  );
};

export default Contact;
